<section class="relative w-auto">
    <p class="relative text-gray-#252525 font-Lato-Regular font-semibold
    us:text-sm
    lg-landscape:text-sm">
        <span (click)="gotoRoute(item?.route)" class="cursor-pointer" *ngFor="let item of data; let i=index">
            {{item.section | translate: item.params}} <span *ngIf="i !== data?.length - 1"> > </span></span>
    </p>
</section>
